<template>
  <div :class="classes">
    <div
      class="
        bg-primary
        user-card-avatar
        d-flex
        align-items-center
        justify-content-center
        rounded-circle
        text-white
        fs-3
      "
    >
      {{user.email.charAt(0).toUpperCase()}}
    </div>
    <div class="d-flex flex-column">
      <span class="fw-bold fs-6">{{user.email}}</span>
      <span class="fs-14px text-secondary">{{user.permission}}</span>
    </div>
    <div class="ms-auto">
        <button class="btn"><img src="@/assets/images/trash.svg" alt=""></button>
        <button class="btn"><img src="@/assets/images/pen.svg" alt=""></button>
    </div>
  </div>
</template>

<script>
export default {
    props: ['user','classes']
};
</script>

<style>
</style>